import z from 'zod';
import { PaymentSettingsWithOptionsWithBillingIntervalResponseSchema } from '../finance-settings/payment-settings.ts';
import { PRODUCT_CATEGORY_SCHEMA } from '../order-product/product-category.ts';
import { ORDER_ORGANIZATION_ROLE_SCHEMA } from '../finance-settings/role.ts';
import { TransactionalTotalsSchema } from './totals.ts';
import { TransactionWithQuoteStatusSchema } from './transactions.ts';
import { SUPPORTED_UNITS_SCHEMA } from '../quote-unit/unit-types.ts';

export const PostFulfillmentSummaryByPositionPathUrlSchema = z.object({
    positionId: z.string().uuid(),
});

export const PostFulfillmentSummaryByPositionResponseSchema = z.object({
    organizations: z.array(
        z.strictObject({
            orgId: z.number(),
            functionalRoles: z.array(ORDER_ORGANIZATION_ROLE_SCHEMA),
            totals: z.array(TransactionalTotalsSchema),
            transactions: z.array(TransactionWithQuoteStatusSchema),
            financeSettings: z.array(PaymentSettingsWithOptionsWithBillingIntervalResponseSchema),
        })
    ),
});

export const PostFulfillmentSummaryByPositionRequestSchema = z.object({
    products: z.array(
        z.object({
            name: z.string(),
            positionProductId: z.string().uuid(),
            productCategory: PRODUCT_CATEGORY_SCHEMA,
            partnerOrganizationId: z.number(),
            orderingOrganizationId: z.number(),
            sflxPlatformId: z.number(),
            purchasePrice: z.number(),
            salesPrice: z.number(),
            currencyCode: z.string().length(3),
            unit: SUPPORTED_UNITS_SCHEMA,
            quantity: z.number().min(0),
        })
    ),
});
